// extracted by mini-css-extract-plugin
module.exports = {"main":"nav_main__2HOC6","standard":"nav_standard__4OVtk","atv":"nav_atv__qGcJ6","btnIcon":"nav_btnIcon__61PzR","trigger":"nav_trigger__tVIUi","moreIcon":"nav_moreIcon__mCVDS"};